"use strict";

import angular from "angular";

import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import Highcharts from "highcharts";
import {
    dark,
    light
} from "../../../presentation/services/HighchartsTheme/HighcharttsTheme";
import template from "./chart.component.html";
import "./themes/chart.component.scss";
import "./themes/chart.component-dark.scss";

require("highcharts/highcharts-more")(Highcharts);

/**
 * @component nuChart
 * O <nu-chart> exibe gráficos de acordo com a configuração passada
 */

class NuChartCtrl {
    constructor($scope, $timeout, ChartStructure, ThemesService) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.ChartStructure = ChartStructure;
        this.ThemesService = ThemesService;
        Highcharts.setOptions({
            lang: {
                months: [
                    "Janeiro",
                    "Fevereiro",
                    "Março",
                    "Abril",
                    "Maio",
                    "Junho",
                    "Julho",
                    "Agosto",
                    "Setembro",
                    "Outubro",
                    "Novembro",
                    "Dezembro"
                ],
                shortMonths: [
                    "Jan",
                    "Fev",
                    "Mar",
                    "Abr",
                    "Mai",
                    "Jun",
                    "Jul",
                    "Ago",
                    "Set",
                    "Out",
                    "Nov",
                    "Dez"
                ]
            }
        });
        const currentTheme = this.ThemesService.setTheme(
            new UserDataAdapter().user()?.profile?.theme || "light"
        );
        if (currentTheme === "dark") {
            const theme = dark;
            Highcharts.setOptions(theme);
        } else {
            Highcharts.setOptions(light);
        }
    }
    _chartUpdate = () => {
        this.optionsChart = this.visualization?.chart;
        this.chartCategory = this.optionsChart?.category;
        this._afterLoad();
    };
    $onInit() {
        this.optionsChart = this.visualization?.chart;
        this.id = this.ChartStructure.getId(this.visualization._id);
        const deregisterDataVisualizationUpdated = this.$scope.$on(
            "dataVisualizationUpdated",
            this._chartUpdate
        );
        const deregisterTriggerReflow = this.$scope.$on(
            "triggerReflow",
            this.reflow
        );
        const deregisterReflowChartComponent = this.$scope.$on(
            "reflowChartComponent",
            this.reflow
        );
        this.$scope.$on("$destroy", () => {
            deregisterDataVisualizationUpdated();
            deregisterTriggerReflow();
            deregisterReflowChartComponent();
        });
        this.$timeout(this._afterLoad);
    }
    _afterLoad = () => {
        const runningTimeOut = this.$timeout(() => {
            this.chart = this.ChartStructure.generate(
                this.id,
                this.data,
                this.optionsChart
            );
        }, 0);
        this.$scope.$on("$destroy", () => {
            this.$timeout.cancel(runningTimeOut);
        });
    };
    reflow = () => {
        if (this.chart) this.chart.reflow();
    };
}

NuChartCtrl.$inject = ["$scope", "$timeout", "ChartStructure", "ThemesService"];

const name = "nuChart";
const def = {
    bindings: {
        data: "=",
        visualization: "="
    },
    controller: NuChartCtrl,
    controllerAs: "chartCtrl",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
